import { DialogFooter } from 'src/components/ui/dialog';
import { Button as ButtonShad } from 'src/components/ui/button';
import { useAppSelector } from 'src/store';
import { EditZendeskChatIntegrationSettings } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationSettings/EditZendeskChatIntegrationSettings/EditZendeskChatIntegrationSettings';
import { EditZendeskEmailIntegrationSettings } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationSettings/EditZendeskEmailIntegrationSettings/EditZendeskEmailIntegrationSettings';
import { EditZohoSalesIQIntegrationSettings } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationSettings/EditZohoSalesIQIntegrationSettings/EditZohoSalesIQIntegrationSettings';
import { EditZohoEmailIntegrationSettings } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationSettings/EditZohoEmailIntegrationSettings/EditZohoEmailIntegrationSettings';
import { EditFreshchatIntegrationSettings } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationSettings/EditFreshchatIntegrationSettings/EditFreshchatIntegrationSettings';
import { EditFreshdeskEmailIntegrationSettings } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationSettings/EditFreshdeskEmailIntegrationSettings/EditFreshdeskEmailIntegrationSettings';
import type { SelectedIntegration } from 'src/store/slices/integrationSlice';
import type { IntegrationSubmitHandler } from 'src/components/Integrations/integrationFormTypes';

export const EditIntegrationSettings = ({
  onSubmit,
  onCancel,
}: {
  onSubmit: IntegrationSubmitHandler;
  onCancel: () => void;
}) => {
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);

  const renderIntegrationSettingsForm = ({ data }: SelectedIntegration) => {
    switch (data.integration_type) {
      case 'zendesk_chat':
        return (
          <EditZendeskChatIntegrationSettings
            integration={selectedIntegration}
            onSubmit={onSubmit}
          />
        );
      case 'zendesk_email':
        return (
          <EditZendeskEmailIntegrationSettings
            integration={selectedIntegration}
            onSubmit={onSubmit}
          />
        );
      case 'zoho_salesiq':
        return (
          <EditZohoSalesIQIntegrationSettings
            integration={selectedIntegration}
            onSubmit={onSubmit}
          />
        );
      case 'zoho_desk':
        return (
          <EditZohoEmailIntegrationSettings integration={selectedIntegration} onSubmit={onSubmit} />
        );
      case 'freshdesk_chat':
        return (
          <EditFreshchatIntegrationSettings integration={selectedIntegration} onSubmit={onSubmit} />
        );
      case 'freshdesk_email':
        return (
          <EditFreshdeskEmailIntegrationSettings
            integration={selectedIntegration}
            onSubmit={onSubmit}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {renderIntegrationSettingsForm(selectedIntegration)}
      <DialogFooter>
        <div className="sticky bottom-0 w-full">
          <div className="flex w-full items-center justify-center gap-2.5 ">
            <ButtonShad
              type="button"
              variant="outline"
              className="transparent black min-w-28"
              onClick={onCancel}
            >
              Cancel
            </ButtonShad>
            <ButtonShad type="submit" className="min-w-28" form="edit-integration-form">
              Update
            </ButtonShad>
          </div>
        </div>
      </DialogFooter>
    </>
  );
};
